<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" @change="getDevices" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称" >
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="设备编码"  v-if="type==0">
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间范围">
					<el-date-picker
                        v-model="filters.time" type="datetimerange" :picker-options="pickerOptions"  unlink-panels
                        range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"  align="right">
                    </el-date-picker>
                </el-form-item>
                
				<el-form-item>
					<el-button type="primary" v-on:click="getDataList()">查询</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<el-table :data="dataList" border stripe highlight-current-row v-loading="listLoading" style="width: 100%;" :max-height="formHeight"  size="small" >
			<el-table-column type="index" label="序号"  ></el-table-column>
			<el-table-column prop="deviceCode" label="点位编码" ></el-table-column>
			<el-table-column  label="点位名称"  >
				<template slot-scope="scope">
                    <span>{{ deviceMap.get(scope.row.deviceCode) }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="timeStamp" label="拍照时间"  ></el-table-column>
			<el-table-column prop="noise" label="噪声值"  ></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
                    <el-image   style="width: 30px; height: 16px;"  src="/static/query.png"   :preview-src-list="scope.row.srcList">  </el-image>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;"
			 :page-sizes="[ 10, 20, 30,40,50]"   @size-change="handleSizeChange" :current-page.sync="page"></el-pagination>
		</el-col>

		<el-dialog title="视频详情" :visible.sync="soundVisible" top="8vh" >
			<video :src="mp4Src" controls="controls" style="width: 100%;"></video>
		</el-dialog>

	</section>
</template>

<script>
	import { getProjects,getDevicesByProjectId,selectAcousticCamera} from '../../api/api';
	import {formatDate} from '../../../static/fun.js';

	export default {
		data() {
			return {
				filters: {
					projectId:"",
					mn:"",
                    time:''
				},
				pickerOptions: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
				total: 0,
				page:1,
				pageSize:10,
				listLoading: false,
				dataList:[],
				firstFlag:true,
				deviceMap:new Map(),
				devices:[],
				projects:[],
				formHeight:0,
                type:sessionStorage.getItem("type"),
				soundVisible:false,
				mp4Src:''
			}
			
		},
		methods: {
			handleCurrentChange(val) {
				this.page=val;
				this.getDataList();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getDataList();
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
			        if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
			},
			//获取设备列表
			getDevices() {
				let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
					//如果当前已选的设备不属于选中的项目，把设备置空
					this.devices.forEach(item => {
						this.deviceMap.set(item.mnCode,item.name);
					});	
					
					
					if(this.devices.length>0){
						this.filters.mn=this.devices[0].mnCode;
					}
					if(this.firstFlag){
						this.firstFlag=false;
						this.getDataList();
					}
				});
            },
			//获取历史数据信息
			getDataList(){
				var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
					endtime=formatDate(this.filters.time[1]);
                }
				let para = {
					page: this.page,
					limit:this.pageSize,
					deviceCode: this.filters.mn,
					startTime: starttime,
                    endTime: endtime
				};

				if(this.filters.mn==""){
					this.$message({
						message: "未选择设备",
						type: 'warning'
					})
					return;
				}
				this.listLoading = true;
                selectAcousticCamera(para).then((res) => { 
					this.listLoading = false;
					this.noiseDevice=false;
					this.total = res.data.count;
					this.dataList = res.data.data; 
					if(this.dataList.length==0){
						return;
					}
					this.dataList.forEach(element => {
						element.srcList=[window.configuration.minIoUrl+element.fileName];
					});
                }).catch(() => {
					this.listLoading = false;
				});
			},  
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			},
			setTime(){
				var end = new Date();
				var start = new Date();
				start.setTime(start.setDate(start.getDate()-1));
				//设置不同的时间区间
				this.filters.time= [formatDate(start), formatDate(end)];
				this.getProjects();

			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			
			this.setTime();
		}, 
	}

</script>

<style lang="scss">
	.cell{
		text-align: center;
	}
	.timeFar{
		float: right;
		margin-right: 20px;
	}
	.el-form{
		overflow: hidden;
	}
	.el-col-1{
        text-align: center;
    }

	#dialog .el-dialog{
		height: 100%;
	}
	#dialog .el-dialog__body{
		height: 100%;
	}
	#dialog{
		overflow: hidden;
	}
</style>


// WEBPACK FOOTER //
// YNTakePhoto.vue?2a499ac7